<template>
    <div class="cooperate-form"  @mousedown="touchstart" @mouseup="touchend">
        <div class="content-header">
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <template v-if="formInline.classId==8||formInline.classId==16">
                        <el-date-picker v-model="weekValue" type="month" @change="selectMonth"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-date-picker
                                v-model="weekValue"
                                type="week"
                                format="yyyy 第 WW 周" ref="week" placeholder="选择周" value-format="yyyy-MM-dd"
                                :picker-options="{'firstDayOfWeek': 1}" @change="selectWeek">
                        </el-date-picker>
                    </template>

                </el-form-item>
                <el-form-item>
                    <el-select v-model="formInline.status" placeholder="请选择">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCooperativeList">查询</el-button>
                    <el-button type="success" @click="downloadExcel">下载Excel</el-button>
                </el-form-item>
                <template v-if="formInline.classId==16">
                <el-form-item>
                    <el-upload
                            multiple
                            :with-credentials="true"
                            :show-file-list="false"
                            class="upload-demo"
                            :action="importOKRParam"
                            :on-success="uploadSuccess"
                    >
                        <el-button size="small" type="primary">上传OKR<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>

                </el-form-item>
                </template>
            </el-form>
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="姓名" prop="userName"></el-table-column>
                <el-table-column label="期间" prop="periodName"></el-table-column>
                <el-table-column label="填写开始时间">
                    <template slot-scope="scope">
                        <span style="color: #41B883">{{scope.row.startEditTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="填写截止时间">
                    <template slot-scope="scope">
                        <span style="color: #41B883">{{scope.row.endEditTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="填写状态" prop="statusName"></el-table-column>
                <el-table-column v-if="formInline.classId!=3" label="报告状态">
                    <template slot-scope="scope">
                        <template v-if="formInline.classId==12||formInline.classId==13">
                            <el-popover
                                    v-if="scope.row.reportStatus==1"
                                    placement="top"
                                    width="400"
                                    trigger="hover">
                                <div>
                                    <p><b>确认的采访日期和时间: </b>{{scope.row.answerContent}}</p>
                                    <p><b>补充讨论的内容: </b>{{scope.row.answerContent1}}</p>
                                </div>
                                <el-button slot="reference">已接受</el-button>
                            </el-popover>
                            <el-tag v-if="scope.row.reportStatus==0" type="danger">{{scope.row.status==0?'未邀请':'邀请中'}}</el-tag>
                            <el-tag v-if="scope.row.reportStatus==2" type="success">已完成采访</el-tag>
                        </template>
                        <template v-else>
                            <el-tag v-if="formInline.classId==1&&scope.row.reportStatus==1" type="success">已合格</el-tag>
                            <el-tag v-if="formInline.classId==1&&scope.row.reportStatus==0" type="Warning">暂未合格</el-tag>
                            <el-tag v-if="formInline.classId==2&&scope.row.reportStatus==1" type="success">已合格</el-tag>
                            <el-tag v-if="formInline.classId==2&&scope.row.reportStatus==0" type="Warning">暂未合格</el-tag>


                            <el-tag v-if="formInline.classId==9&&scope.row.reportStatus==0" type="Warning">未评估</el-tag>
                            <el-tag v-if="formInline.classId==9&&scope.row.reportStatus==1" type="Warning">部分完成</el-tag>
                            <el-tag v-if="formInline.classId==9&&scope.row.reportStatus==2" type="success">全部完成</el-tag>
                            <el-tag v-if="formInline.classId==9&&scope.row.reportStatus==3" type="Warning">全部未完成</el-tag>

                            <el-tag v-if="formInline.classId==8&&scope.row.reportStatus==0" type="Warning">未评价</el-tag>
                            <el-tag v-if="formInline.classId==8&&scope.row.reportStatus==1" type="success">复盘有深度</el-tag>
                            <el-tag v-if="formInline.classId==8&&scope.row.reportStatus==3" type="danger">复盘深度不足</el-tag>
                            <el-tag v-if="formInline.classId==8&&scope.row.isNice==1" type="danger">优秀复盘</el-tag>

                        </template>

                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isEdit==1" type="danger" size="mini" @click="getCooperativeQues(scope.row)">修改</el-button>
                        <el-button v-if="scope.row.isEdit==0" :type="scope.row.isLeader==0||scope.row.isLeader==2?'warning':'success'" size="mini" @click="getCooperativeQues(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="pagination-wrap"  >
            <el-pagination
                    background
                    :hide-on-single-page="formInline.pageSize>=recordsTotal"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"

                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-drawer
                :title="title"
                :visible.sync="drawerShow"
                direction="rtl"

                :before-close="handleClose"  size="85%" style="margin-bottom:0px;">

            <cooperative :param="paper" v-if="reFresh" @drawClose="drawClose" ></cooperative>
        </el-drawer>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getCustomerList,uploadCooperativeFile,downloadExcelCooperative,importOKR} from '@/api/api';
    import {getRouterPageHash} from '@/api/http';

    import cooperative from '@/components/cooperative/cooperativePersonal'


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                quesList:[],
                weekValue:new Date(),
                statusList:[{value:null,name:"全部"},{value:0,name:"未填写"},{value:1,name:"已填写"}],
                weekText:'',
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:1,
                    year:'',
                    period:'',
                    userId:'',
                    status:null,
                },
                recordsTotal:0,
                drawerShow:false,
                editIs:0,
                voitIs:0,
                leaderIs:0,
                periodId:'',
                paperId:'',
                fileObjList:[],
                uploadFile:uploadCooperativeFile,
                userAllList:[],
                selectUserList1:[],
                selectUserList:[],
                currentSelectIndex:-1,
                showDialog:false,
                dialogType:1,
                likeCommitContent:'',
                showDialogLeader:false,
                reportStatus:0,
                reportFinish:0,
                isNice:0,
                userId:'',
                title:'内容(*必填)',
                isLeaderEdit:0,
                isDissentEdit:0,
                weekSelectList:[
                    {text:'周一',value:'1'},
                    {text:'周二',value:'2'},
                    {text:'周三',value:'3'},
                    {text:'周四',value:'4'},
                    {text:'周五',value:'5'},
                    {text:'周六',value:'6'},
                    {text:'周日',value:'7'},
                ],
                allChecked:false,
                unChecked:false,
                reFresh:true,
                paper:{},
                X:0,
                Y:0,
                isEnableClose:1,
                importOKRParam:importOKR
            }
        },
        props:['sectionClassId'],
        computed:{

        },
        components:{
            cooperative
        },
        watch:{
            title(){

                this.reFresh= false
                this.$nextTick(()=>{

                    this.reFresh = true
                })
            }
        },
        //挂载时候执行
        mounted() {
            this.formInline.classId = this.sectionClassId
            this.getCooperativeList()
//            this.getCooperativeAllUserList()
            if(this.formInline.classId==8||this.formInline.classId==16){
                this.selectMonth(new Date())
            }else{
                this.selectWeek(new Date())
            }


        },
        methods: {
            //定义查询方法
            getCooperativeList() {
                this.$store.dispatch('initCooperativeList',this.formInline).then(res=>{
                    this.dataList = res.list
                    this.recordsTotal = res.total
                })
            },
            getCooperativeQues(obj) {
                this.paper=obj;
                var monthReport="";
                if(obj.showMonthReport==1){
                    monthReport="-含月复盘";
                }
                this.title=obj.questionClassName+monthReport+" (标*必填)"+" :【"+obj.userName+"】"+obj.periodName;
                this.drawerShow=true;
            },


            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeList()
            },
            handleClose(done) {
                if(this.isEnableClose==1){
                    console.log("1234567890")
                    this.drawerShow=false;
                    this.getCooperativeList()
                    done();
                }

            },
            drawClose() {
                this.isEnableClose=1;
                this.drawerShow=false;
                //console.log("123456789")
                this.getCooperativeList()

            },
            handleFileChange(file,fileList){
                console.log(file)
                this.fileObjList = this.fileObjList.concat(file.value)
            },
            handleFileView(file){
                window.open(file.url)
            },
            handleFileRemove(file,fileList){
                this.fileObjList = fileList
            },
            querySearchFun(queryString) {
                var restaurants = this.userAllList;
                return queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            },
            querySearch(queryString) {
                this.selectUserList =this.querySearchFun(queryString);
            },
            querySearch1(queryString) {
                this.selectUserList1 = this.querySearchFun(queryString);
            },
            selectFocus(index){
                this.currentSelectIndex = index
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.USER_NAME.indexOf(queryString) >-1);
                }
            },
            addQues(item){
                let _this = this
                item.relationEntityList.push({
                    answerId: null,
                    content: null,
                    createTime: null,
                    id: null,
                    relationUserId: null,
                    relationUserName: null,
                    isLeader:_this.leaderIs
                })
            },
            minuQues(item,rel,index){
                item.relationEntityList.splice(index,1);
                this.formSubmit(item)
            },
            closeLikeDialog(){
                this.likeCommitContent = ''
            },
            selectWeek(val){
                this.$store.dispatch('cooperativeWeekInfo',{date:val}).then(res=>{
                    this.formInline.year = res.headYear
                    this.formInline.period = res.headPeriod

                })
            },
            selectMonth(val){
                this.formInline.year = val.getFullYear()
                this.formInline.period = val.getMonth()+1
            },
            showCommentDialog(type){
                this.dialogType = type
                this.showDialog = true
            },

            changeListSort(item){
                this.formSubmit(item);
                this.$notify({
                    title: '成功',
                    message: 'success',
                    type: 'success'
                });
                // console.log(item.moved)
                // let element = item.moved.element;
                // this.$store.dispatch('modifyPaperAnswerRelationSortInfo',{answerRelationId:element.id,questionId:element.questionId,sort:item.moved.newIndex+1,classId:this.formInline.classId,paperId:this.paperId,userId:this.userId}).then(res=> {
                //     console.log(res)
                //     this.$notify({
                //         title: '成功',
                //         message: 'success',
                //         type: 'success'
                //     });
                // })
            },
            downloadExcel(){
                let url = `${downloadExcelCooperative}?classId=${this.formInline.classId}&year=${this.formInline.year}&period=${this.formInline.period}&pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            // 当鼠标点击时触发，类似onclick事件
            touchstart(e) {
                //console.log(e)
                this.isEnableClose=0;

                this.X=e.clientX;
                this.Y=e.clientY;
            },
            // 当鼠标移动时触发
            touchend(e) {
                console.log(e.clientX,e.clientY)
                if(e.clientX>=this.X-30&&e.clientX<=this.X+30)//&&e.clientY>=this.Y-30&&e.clientY<=this.Y+30
                {
                    this.isEnableClose=1;
                }
                //console.log(e)

            },
            uploadSuccess(res){
                if(res.status==500){
                    let data=res.value;
                    if(data==null){
                        data = [];
                        data= res.message.split(',');
                    }
                    let newDatas = [];
                    const h = this.$createElement;
                    //3.通过循环data数组，调用h方法，将每项值传给h,h('标签名',样式,具体内容)
                    for(let i in data){
                        //4.将data数据push进newDatas数组中
                        newDatas.push(h('p',null,data[i]));
                    };
                    this.$message({
                        showClose: true,
                        message:h('div',null, newDatas),
                        type: 'error'
                    });
                }
                if(res.status==400){
                    this.$message({
                        showClose: true,
                        message: "请上传excel文件",
                        type: 'error'
                    });
                }
                if(res.status==200){
                    //2.新建newDatas数组
                    let data=res.value;


                    this.$message({
                        showClose: true,
                        message:  "保存成功",
                        type: 'success'
                    });
                }
            },
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__body{
        overflow-y: scroll;
    }

    .el-textarea__inner{
        min-height: 40px !important;
    }
    .cooperate-form {
        .el-input-number{
            width: 220px !important;
        }
        .el-select{
            width: 100%;
        }
    }
    .drag-container{
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        td,th{
            padding: 12px 0;
            border:1px solid #EBEEF5;

        }
        th{
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativeFormPersonal.vue